import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Tabs, Tab, TabProps } from "@mui/material";
import { PermissionRequired } from "lib-core";
import appViews from "../../router/views";

type RouterTabProps = TabProps<typeof Link, { to: string }>;
const RouterTab = Tab as React.ComponentType<RouterTabProps>;

const HeaderNavigation: () => JSX.Element = () => {
  const location = useLocation();

  return (
    <Tabs component="nav" value={0}>
      {appViews
        .filter((view) => !view.home.disabled)
        .filter((view) => !view.home.name.includes("Error"))
        .map((view) => {
          const { name, path, requiredKeys } = view.home;
          const to = `/${path}`;
          const selected = location.pathname === to;

          return (
            <PermissionRequired
              key={name}
              path={to.substring(1)}
              permissionKeys={requiredKeys}
            >
              <RouterTab
                label={name}
                component={Link}
                className={selected ? "Mui-selected" : ""}
                to={path}
                data-testid={`header-navigation-link-${path}`}
              />
            </PermissionRequired>
          );
        })}
    </Tabs>
  );
};

export default HeaderNavigation;
